export default function changeWaLocal(language) {
	if (language) {
		utag_data.wa_local = language
		window.wapLocalCode = language
	} else {
		utag_data.wa_local = 'br-pt'
		window.wapLocalCode = 'br-pt'
	}
}
